import ApiService from "../../commons/services/ApiService";
import CompanyAPI from "../company/CompanyAPI";

const apiService = new ApiService();
const companyAPI = new CompanyAPI()
export default class MetaAPI {

    URI_V1 = "/v1/meta"

    handleCallback = async (data: any) => {
        return await apiService.post(`${this.URI_V1}/oauth/callback`, data);
    };

    checkConnection = async () => {
        return await apiService.get(`${this.URI_V1}/check-connection?companyId=${companyAPI.getCompanyManagment().id}`);
    };

    disconnect = async () => {
        return await apiService.delete(`${this.URI_V1}/disconnect?companyId=${companyAPI.getCompanyManagment().id}`);
    };

    getAdAccounts = async () => {
        return await apiService.get(`${this.URI_V1}/ad-accounts?companyId=${companyAPI.getCompanyManagment().id}`);
    };

    getPages = async () => {
        return await apiService.get(`${this.URI_V1}/ad-pages?companyId=${companyAPI.getCompanyManagment().id}`);
    };

    createAd = async (data: any) => {
        return await apiService.postFormData(`${this.URI_V1}/ads`, data);
    };

    updateAd = async (data: any) => {
        return await apiService.putFormData(`${this.URI_V1}/ads`, data);
    };

    getLocations = async (text: any, adAccountId: any) => {
        return await apiService.get(`${this.URI_V1}/search?adAccountId=${adAccountId}&companyId=${companyAPI.getCompanyManagment().id}&query=${encodeURIComponent(text)}&type=city`);
    };

    getInterests = async (text: any, adAccountId: any) => {
        return await apiService.get(`${this.URI_V1}/search?adAccountId=${adAccountId}&companyId=${companyAPI.getCompanyManagment().id}&query=${encodeURIComponent(text)}&type=adinterest`);
    };

    getSeggestedInterests = async (text: any, adAccountId: any) => {
        return await apiService.get(`${this.URI_V1}/search?adAccountId=${adAccountId}&companyId=${companyAPI.getCompanyManagment().id}&query=${encodeURIComponent(text)}&type=adinterestsuggestion`);
    };

    getAnnouncements = async (isoStart: any, isoEnd: any) => {
        return await apiService.get(`${this.URI_V1}/announcements?companyId=${companyAPI.getCompanyManagment().id}&startDate=${isoStart}&endDate=${isoEnd}`);
    };

    deleteAnnouncements = async (internalId: any) => {
        return await apiService.delete(`${this.URI_V1}/announcement/${internalId}`);
    };

    updateAnnouncementStatus = async (internalId: any, status: any) => {
        return await apiService.patch(`${this.URI_V1}/announcement/${internalId}?status=${status}`, {});
    };

    getPreviews = async (internalId: any) => {
        return await apiService.get(`${this.URI_V1}/announcement/${internalId}/previews`, {});
    };


}
